export const detectTextDir = (text, fallback = "rtl") => {
  if (!text || !String(text).trim()) return fallback;
  const stripped = String(text).replace(/<[^>]+>/g, " ");
  const arabic = (stripped.match(/[\u0600-\u06FF]/g) || []).length;
  const english = (stripped.match(/[a-zA-Z]/g) || []).length;
  if (english > arabic) return "ltr";
  if (arabic > english) return "rtl";
  return fallback;
};

export const formatSharedDate = (value, dir) => {
  if (!value) return null;
  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString(dir === "rtl" ? "ar-EG" : "en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return null;
  }
};
